import { CompactTableRow } from 'components/data_table/CompactTableRow';
import { FullTableRow } from 'components/data_table/FullTableRow';
import { StyledTableFoot } from 'components/data_table/styled';
import { BaseTableHeaderFooter, TableProps } from 'components/data_table/types';

export type TableFooterProps<TData> = BaseTableHeaderFooter<TData> &
    Pick<TableProps<TData>, 'footerAriaDescription'>;

export function TableFooter<TData>({
    columns,
    tableStyle,
    isCompact,
    primaryColumns,
    secondaryColumns,
    lockStyles,
    footerAriaDescription,
}: TableFooterProps<TData>) {
    return (
        <StyledTableFoot $isCompact={isCompact}>
            {isCompact ? (
                <CompactTableRow
                    ariaDescription={footerAriaDescription ?? 'Footer'}
                    tableStyle={tableStyle}
                    primaryColumns={primaryColumns}
                    secondaryColumns={secondaryColumns}
                    valueCell={(columnInfo) =>
                        columnInfo.footer ? (
                            columnInfo.footer({
                                isCompact: true,
                                columnInfo,
                            })
                        ) : (
                            <></>
                        )
                    }
                />
            ) : (
                <FullTableRow
                    tableStyle={tableStyle}
                    columns={columns}
                    lockStyles={lockStyles}
                    valueCell={(columnInfo) =>
                        columnInfo.footer ? (
                            columnInfo.footer({
                                isCompact: false,
                                columnInfo,
                            })
                        ) : (
                            <></>
                        )
                    }
                />
            )}
        </StyledTableFoot>
    );
}
